import {fromEvent} from "rxjs";
import {map, tap} from "rxjs/operators";
import getOwnPropertyDescriptor = Reflect.getOwnPropertyDescriptor;

export interface AccordianOnOpenAndClose {
    [key: string] : {
        open(el: any) : any;
        close(el: any) : any;
    }
}

export const closeAccordContent = (el, content, extraFunc) => {
    // console.log(extraFunc);
    jQuery(el).removeClass('accord-open');
    window.setTimeout( () => {
        content.style.removeProperty( 'height' );
    } );
    if(extraFunc){
        extraFunc.close(el);
    }
};
export const initAccordians = (runOnOpenClose: AccordianOnOpenAndClose = {}) => {

    console.log('INIT ACCORDIANS');

    const close = (el, content, extraFunc) => {
        console.log(extraFunc);
        jQuery(el).removeClass('accord-open');
        window.setTimeout( () => {
            content.style.removeProperty( 'height' );
        }, 16);
        if(extraFunc){
            extraFunc.close(el);
        }
    };

    const open = (el, content, extraFunc) => {
        jQuery(el).addClass('accord-open');
        content.addEventListener( 'transitionend', () => {
            content.style.removeProperty( 'height' );
        }, { once: true } );
        if(extraFunc){
            extraFunc.open(el);
        }
    };

    fromEvent(jQuery('.accord-head'), 'click').pipe(
        map( (e: any) => {
            console.log('click accordian');
            let p = jQuery(e.currentTarget).data('accord-parent')
            if(p){
                p = jQuery(e.currentTarget).closest(p)[0]
            }
            // console.log('CLOSEST', p);
            return p ? p : e.currentTarget.parentElement;
        }),
        // tap( el => jQuery(el).toggleClass('open') ),
        // map( el => jQuery(el).hasClass('open')),
        tap( el => {
            // console.log(jQuery(el.parentElement).data('maxSingle'));
            let openClose = jQuery(el.parentElement).data('openClose');
            // if(group.data())
           /* if(jQuery(el.parentElement).data('maxSingle')){
                // console.log('maxsingle');
                let open = jQuery(el).parent().find('.accord-open');
                // console.log(open);
                if ( open.length > 0 && open.get(0) !== jQuery(el).get(0) ){
                    let openContent = open.find('.accord-content').get(0);
                    openContent.style.height = openContent.scrollHeight + 'px';
                    close(open.get(0), openContent, runOnOpenClose[openClose] )
                    // console.log('another open');
                }
            }*/
            const content = jQuery(el).find('.accord-content').get(0);
            if( !content){
                return;
            }
            content.style.height = content.scrollHeight + 'px';
            if(!jQuery(el).hasClass('accord-open')){
                /*jQuery(el).addClass('open');
                content.addEventListener( 'transitionend', () => {
                    content.style.removeProperty( 'height' );
                }, { once: true } );*/
                open(el, content, runOnOpenClose[openClose]);
            } else {
               /* jQuery(el).removeClass('open');
                window.setTimeout( () => {
                    content.style.removeProperty( 'height' );
                } );*/
                close(el, content, runOnOpenClose[openClose]);
            }
        })
    ).subscribe();

}
